// eslint-disable-next-line no-unused-vars
import React from 'react'
import { connect } from 'react-redux'
import { actions } from './'
import Scheduling from './Scheduling'
import { actions as actionsCellphoneRecharge } from 'features/CellphoneRecharge'

const mapStateToProps = ({
  scheduling: {
    scheduledOrders,
    scheduledOrder,
    nextOrders,
    participantSchedulesModel,
    indexServiceItem,
    isLoadingUpdate,
    isLoadingInsert
  },
  cellphoneRecharge: { loadingScheduleOrder }
}) => {
  return {
    scheduledOrders,
    scheduledOrder,
    nextOrders,
    participantSchedulesModel,
    indexServiceItem,
    isLoadingUpdate,
    isLoadingInsert: loadingScheduleOrder
  }
}

const mapDispatchToProps = dispatch => ({
  getScheduledOrders: date => dispatch(actions.getScheduledOrders(date)),
  editServiceItem: item => dispatch(actions.editServiceItem(item)),
  deleteServiceItem: index => dispatch(actions.deleteServiceItem(index)),
  newServiceItem: () => dispatch(actions.newServiceItem()),
  updateScheduleOrder: scheduleOrder =>
    dispatch(actions.updateScheduleOrder(scheduleOrder)),
  cancelServiceItem: scheduleOrder =>
    dispatch(actions.cancelServiceItem(scheduleOrder)),
  insertScheduleOrder: (
    serviceId,
    operatorKey,
    areaCode,
    phone,
    initialScheduleDate,
    endScheduleDate,
    creditValue,
    pointValue
  ) =>
    dispatch(
      actionsCellphoneRecharge.scheduleMobileRecharges(
        serviceId,
        operatorKey,
        areaCode,
        phone,
        initialScheduleDate,
        endScheduleDate,
        creditValue,
        pointValue
      )
    )
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Scheduling)



// WEBPACK FOOTER //
// ./src/Participant/Scheduling/SchedulingContainer.js